<template>

  <thead>
  <tr>
    <th :style="{width: '60px'}" v-if="hasSelect"
    >
      <a-checkbox v-if="!singleSelect" :checked="allValuesAreSelected" @change="$emit('toggle-all')" class="pr-xs"></a-checkbox>
    </th>
    <template v-for="(header, idx) in headers" >
      <th class="cell" :style="{'width': header.width }">
        <dd-order-by
          v-if="header.title"
          :header="header"
          :key="idx"
          :load-page-object="loadPageObject"
          @change="onOrderBy"
        >
          {{ header.title }}
        </dd-order-by>
        <div v-else style="min-height: 16px"/>
      </th>
    </template>
    <th :style="{width: actionWidth}" v-if="hasActionButtons"></th>
  </tr>
  </thead>
</template>

<script>

export default {
  name: "DdTableHeader",
  emits: ['on-order-by', 'toggle-all'],
  props: {
    actionWidth: {
      type: String,
    },
    headers: {
      type: Array,
      required: true,
    },
    hasSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    singleSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    loadPageObject: {
      type: Object,
      required: false
    },
    allValuesAreSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    hasActionButtons: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  methods: {
    onOrderBy(column, order) {
      this.$emit('on-order-by', order, column);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

</style>
